import React from 'react';
import { DiaryEntry } from './DiaryEntry';
const entries = [{
  date: '12. Januar 2026',
  title: 'Der Schock',
  content: 'Oskar hörte auf zu fressen. Würgte. Sein Bauch war hart. Notaufnahme beim Tierarzt. Röntgen: ein Stück Spielzeug. Operation. Ich saß vier Stunden im Wartezimmer und betete. Er hat es geschafft.'
}, {
  date: '23. Januar 2026',
  title: 'Die Erholung',
  content: 'Oskar kommt nach Hause. Der Darm ist geschwächt. Schonkost. Wenig Bewegung. Der Tierarzt empfiehlt sanfte Unterstützung für die Darmflora. Ich recherchiere. Ich finde ein pflanzliches Topping mit Präbiotika und schützenden Ballaststoffen.'
}, {
  date: '12. Februar 2026',
  title: 'Der Wiederaufbau',
  content: 'Ich schleiche das Topping ganz langsam ein. Winzige Mengen zunächst. Oskars Verdauung stabilisiert sich. Der Stuhl normalisiert sich. Er frisst wieder mit Appetit. Sein Bauch entspannt sich.'
}, {
  date: '8. März 2026',
  title: 'Heute',
  content: 'Oskar ist wieder er selbst. Das Topping bleibt – als tägliche Vorsorge damit sein Darm stark und geschützt bleibt. Ich gebe es ihm nun dauerhaft. Nach diesem Erlebnis nehme ich Darmgesundheit sehr ernst.'
}];
export function DiarySection() {
  return <section className="w-full py-12 px-4 md:px-8 max-w-3xl mx-auto relative" data-id="element-38">
      {/* Vertical connecting line for diary feel */}
      <div className="absolute left-8 md:left-12 top-24 bottom-12 w-px bg-warm-brown/20 hidden md:block" data-id="element-39" />

      <div className="space-y-12" data-id="element-40">
        {entries.map((entry, index) => <div key={index} className="relative" data-id="element-41">
            {/* Timeline dot */}
            <div className="absolute -left-5 md:-left-[21px] top-8 w-3 h-3 rounded-full bg-forest-green hidden md:block border-4 border-cream box-content" data-id="element-42" />
            <DiaryEntry index={index} date={entry.date} title={entry.title} content={entry.content} data-id="element-43" />
          </div>)}
      </div>
    </section>;
}